// src/constants.ts
export const BYE = "BYE";